import { useLocation } from 'react-router-dom';

import StaticSeoHead from '@/shared-components/seo/StaticSeoHead';

import { buildProfileSubpageSeoMetadata } from './profileSubpageSeo.utils';

export default function MetaDescripProfilePages({
  fetchData,
  subPage,
  internal = false,
  itemCount = 0,
  secondaryCount = 0,
  boardView = 'posts',
  communityView = 'thoughts',
}) {
  const location = useLocation();
  const metadata = buildProfileSubpageSeoMetadata(fetchData, {
    subPage,
    internal,
    pathname: location.pathname,
    search: location.search,
    boardView,
    communityView,
    itemCount,
    secondaryCount,
  });

  return (
    <StaticSeoHead
      title={metadata.title}
      description={metadata.description}
      canonicalUrl={metadata.canonicalUrl}
      robots={metadata.robots}
      ogType="profile"
      image={metadata.image}
      pageType={metadata.pageType}
      breadcrumbItems={metadata.breadcrumbItems}
      structuredData={metadata.structuredData}
    />
  );
}
